import React, { useState } from 'react';
import AboutBanner from '../../components/about/aboutBanner';
import Features from '../../components/about/features';
import TotalFloors from '../../components/about/totalFloors';
import Specification from '../../components/about/specification';
import PagesFooter from '../../shared/pagesFooter';

const AboutPage = () => {
  const [selectedType, setSelectedType] = useState("Designer Suite");
  return (
    <div>
      <AboutBanner />
      <div id="features-section">
        <Features />
      </div>
      <div id="total-floors-section">
        <TotalFloors selectedType={selectedType} setSelectedType={setSelectedType} />
      </div>
      <div id="specifications-section">
        <Specification selectedType={selectedType}/>
      </div>
      <PagesFooter />
    </div>
  );
};

export default AboutPage;
